import React from 'react';
import { connector } from '../store';
import type { Element } from 'react';
import { getBasicVideoTrackingLabel } from '../helpers';

import ga from '../../../vendor/google-analytics';
import $ from 'jquery';
import cookie from '../../../vendor/jquery.cookie';
import PassportLockup from './PassportLockup';

let trackingCategory = 'VideoPlayer | Passport Overlay';

function Overlay({ children, actionText, dest, action }: { children: Element<any>, actionText: ?string, dest: ?string, action: ?Function }): Element<any> {
  return (
    <div className="video-player-passport-overlay">
      <div className="passport-overlay-content">
        <PassportLockup />
        <p className="body-large passport-overlay-message">
          {children}
        </p>
        {
          actionText && dest &&
          <a className="no-delay passport-outline-btn passport-interaction" href={dest} target="_parent" onClick={action}>
            {actionText}
          </a>
        }
      </div>
    </div>
  );
}

let TermsBanner = connector(function TermsBanner(props: any): Element<any> {
  let { show, src, player } = props;

  return <VideoPlaceholder src={src}>
    <Overlay actionText="View Terms" dest="/passport/agree/" action={() => {

      // Update the last known location of the user before they enter sign in land
      $.cookie('location_before_signin', window.location.href, { path: '/' });
      ga('send', 'event', trackingCategory, 'Click Terms | [A]', getBasicVideoTrackingLabel(show, player));
    }}>
      We've updated our terms of service.
    </Overlay>
  </VideoPlaceholder>;
});

let ExpiredBanner = connector(function ExpiredBanner(props: any): Element<any> {
  let { src } = props;

  return <VideoPlaceholder src={src}>
    <Overlay>
      <span>
        This video is not currently available.<br />
        Find out more by visiting our <a href="/frequently-asked-questions/" className="no-delay" target="_parent">FAQs page</a>.
      </span>
    </Overlay>
  </VideoPlaceholder>;
});


let PassportActivationBanner = connector(function PassportActivationBanner(props: any): Element<any> {
  let { src, show, player } = props;

  return <VideoPlaceholder src={src}>
    <Overlay actionText="Activate Account" dest="/activate/" action={() => {
      ga('send', 'event', trackingCategory, 'Click Activate | [A]', getBasicVideoTrackingLabel(show, player))
    }}>
      Access to this video is a benefit for TPT members
    </Overlay>
  </VideoPlaceholder>;
});

let PassportSignUpBanner = connector(function PassportSignUpBanner(props): Element<any> {
  let { src, show, player } = props;

  return <VideoPlaceholder src={src}>
    <Overlay actionText="Learn More" dest="/passport/" action={() => {

      // Update the last known location of the user before they enter sign in land
      $.cookie('location_before_signin', window.location.href, { path: '/' });
      ga('send', 'event', trackingCategory, 'Click Learn More | [A]', getBasicVideoTrackingLabel(show, player))
    }}>
      Access to this video is a benefit for TPT members
    </Overlay>
  </VideoPlaceholder>;
});

export default function VideoPlaceholder({ src, children }: { src: string, children: Element<any> }): Element<any> {
  return (
    <div>
      <img className="aspect-controlled" src={`${src.replace(/http:/, '')}.fit.980x551.jpg`} />
      {children}
    </div>
  );
}

export { ExpiredBanner, PassportActivationBanner, PassportSignUpBanner, TermsBanner };